/**
 * Teksten van Account: je eigen apparaten en je wachtwoord. Jij-vorm, labels zijn
 * zelfstandige naamwoorden, knoppen werkwoorden.
 */
export const accountCopy = {
    title: 'Account',
    /** Het gebruikersblok onderaan de rail opent Account. */
    railLink: (name: string) => `Account van ${name}`,
    eyebrow: (name: string, email: string) => `${name} · ${email}`,

    /* Apparaten */
    devicesTitle: 'Apparaten met toegang',
    devicesIntro:
        'Elk apparaat waarop je bent ingelogd. Kwijt of niet meer in gebruik? Trek het in: het wordt meteen uitgelogd en kan niet meer inloggen met je account, tot je het hier weer toelaat.',
    devicesLoading: 'Apparaten laden',
    devicesError: 'Je apparaten konden niet geladen worden',
    devicesEmpty: 'Er zijn geen apparaten met toegang.',
    thisDevice: 'Dit apparaat',
    statusActive: 'Toegang',
    statusRevoked: 'Ingetrokken',
    statusExpired: 'Opnieuw inloggen',
    fieldDevice: 'blijft 14 dagen ingelogd',
    officeDevice: 'blijft 12 uur ingelogd',
    lastSeen: (when: string) => `Laatst gebruikt ${when}`,
    neverSeen: 'Nog niet gebruikt',
    lastSync: (when: string) => `laatst gesynchroniseerd ${when}`,
    trustedUntil: (when: string) => `Ingelogd tot ${when}`,
    revokedOn: (when: string) => `Ingetrokken op ${when}`,

    rename: 'Naam wijzigen',
    renameLabel: (name: string) => `Nieuwe naam voor ${name}`,
    renameSave: 'Naam opslaan',
    renameRequired: 'Geef dit apparaat een naam.',
    renamed: (name: string) => `Het apparaat heet nu ${name}.`,

    revoke: 'Intrekken',
    revokeLabel: (name: string) => `Bevestig intrekken van ${name}`,
    revokeBody: (name: string) =>
        `${name} wordt meteen uitgelogd en kan daarna niet meer inloggen met je account, tot je het weer toelaat. Wat er op dat apparaat nog niet was gesynchroniseerd, komt niet meer binnen.`,
    revokeYes: 'Ja, apparaat intrekken',
    revoked: (name: string) => `${name} is ingetrokken.`,

    restore: 'Weer toelaten',
    restored: (name: string) =>
        `${name} is weer toegelaten. Log daar in met je wachtwoord om verder te werken.`,
    currentNote:
        'Dit apparaat trek je niet hier in: dan kun je er niet meer inloggen. Wil je stoppen, log dan uit.',
    cancel: 'Annuleren',

    /* Wachtwoord */
    passwordTitle: 'Wachtwoord wijzigen',
    passwordIntro:
        'Na het wijzigen blijf je hier ingelogd. Op al je andere apparaten moet je opnieuw inloggen.',
    currentPassword: 'Huidig wachtwoord',
    newPassword: 'Nieuw wachtwoord',
    newPasswordHint: 'Minstens 12 tekens, en niet een wachtwoord dat je ergens anders gebruikt.',
    confirmPassword: 'Herhaal nieuw wachtwoord',
    passwordSubmit: 'Wachtwoord wijzigen',
    passwordBusy: 'Bezig met wijzigen…',
    currentRequired: 'Vul je huidige wachtwoord in.',
    newRequired: 'Kies een nieuw wachtwoord.',
    newTooShort: 'Gebruik minstens 12 tekens.',
    confirmRequired: 'Herhaal je nieuwe wachtwoord.',
    mismatch: 'De twee wachtwoorden zijn niet gelijk.',
    sameAsCurrent: 'Kies een ander wachtwoord dan je huidige.',

    /* Rondleiding */
    tourTitle: 'Rondleiding',
    tourIntro:
        'Nog eens zien waar alles staat? De rondleiding duurt een minuut en wijst de belangrijkste plekken aan.',
    tourRestart: 'Rondleiding opnieuw bekijken',

    failed: 'Dat lukte niet. Probeer het opnieuw.',
} as const;
